//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faHouseUser, faWater } from "@fortawesome/free-solid-svg-icons";


//IMG
import appartmentImg from "../../../public/assets/images/inHome/tipoAppartamento.jpg";
import houseImg from "../../../public/assets/images/inHome/tipoCasa.jpg";
import holidayHomesImg from "../../../public/assets/images/inHome/tipoCasaVac.jpg";



const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();
        
    return (
        <section id="searchForTipology" className="space-ptb">
            <div className="container-fluid">
                <h2 className="mb-4">{t('homePage.searchForTypo.title')}</h2>
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-6 col-xl-4 mb-4">
                        <Link to="/immobili/vendita/appartamento" className="w-100 d-block" title={`${t('homePage.searchForTypo.typology1Text')}`}>
                            <img src={appartmentImg} className="img-fluid" alt={`${t('homePage.searchForTypo.imgAlt1')}`} />
                            <p className="text-center">
                                {t('homePage.searchForTypo.typology1Text')}
                                <FontAwesomeIcon icon={faBuilding} />
                            </p>
                        </Link>
                    </div>
                    <div className="col-12 col-sm-10 col-md-6 col-xl-4 mb-4">
                        <Link to="/immobili/vendita?tipologia=5&tipologia=6&tipologia=18&tipologia=15" className="w-100 d-block" title={`${t('homePage.searchForTypo.typology2Text')}`}>
                        <img src={houseImg} className="img-fluid" alt={`${t('homePage.searchForTypo.imgAlt2')}`} />
                            <p className="text-center">
                                {t('homePage.searchForTypo.typology2Text')}
                                <FontAwesomeIcon icon={faHouseUser} />    
                            </p>
                        </Link>
                    </div>
                    <div className="col-12 col-sm-10 col-md-6 col-xl-4 mb-4">
                        <Link to="/immobili/affitto-vacanze" className="w-100 d-block" title={`${t('homePage.searchForTypo.typology3Text')}`}>
                            <img src={holidayHomesImg} className="img-fluid" alt={`${t('homePage.searchForTypo.imgAlt3')}`} />
                            <p className="text-center">
                                {t('homePage.searchForTypo.typology3Text')}
                                <FontAwesomeIcon icon={faWater} />
                            </p>
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center text-lg-left">
                        <div className="d-lg-flex justify-content-between align-items-center mt-5 bg-dark p-4 px-lg-5">
                            <p className="mb-4 mb-lg-0" dangerouslySetInnerHTML={{ __html: t('homePage.searchForTypo.landingPara') as string }} />
                            <a href="https://casavenditavada.it/" className="btn btn-primary ml-lg-4" target="_blank" title={`${t('homePage.searchForTypo.landingBtnText')}`}>
                                <span>{t('homePage.searchForTypo.landingBtnText')}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
